import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPyton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-pyton';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "m8.39 4.132-.99.885V7.08l-.93.002-.93.001-1.15.82-1.15.819v3.209l.001 3.209.942.81.942.81H6.72v2.234l.99.883.99.883h5.902l.999-.889.999-.888V16.96h1.792l1.174-.832 1.174-.832.01-3.218.009-3.218-.942-.81-.943-.81H17.28V5.005l-.99-.882-.99-.881-2.96.002-2.96.002zm6.864 1.075.506.448v5.985H6.72v3.6h-.53l-.53-.001-.45-.384-.45-.384V9.483l.65-.462.65-.461h6.38V7.08H8.92l.003-.71.002-.71.508-.449.507-.45h2.404l2.404-.001zm3.536 3.94.451.388-.011 2.5-.01 2.5-.637.452-.637.453H11.56v1.52h3.52l-.002.69-.001.69-.509.449-.508.449-2.404.001-2.404.001-.506-.447-.506-.448V13.12h9.04V8.76h1.06z"
    })
  }));
});
export default SvgPyton;